module.exports = __webpack_public_path__ + "media/blackjack-video.84a91f5f.mp4";